module.exports = __webpack_public_path__ + "static/media/notification.03b08279.png";